// ///////////////////////////////////////////////////////
// Composant pour la gestion des altimetries
// ///////////////////////////////////////////////////////
// Creation : 04/07/2022    -> CGR
// ///////////////////////////////////////////////////////

// Imports system
import React, { useEffect, useState, useContext } from 'react';


// Imports src
import useKrpano from 'react-krpano-hooks'
import Palette from './../../components/palette/palette';
import {pageContext, programmeNameContext, programmeContext, noHeaderContext, state} from './../../contexts';
import Annotation from '../../components/annotation/annotation';
import SvgIcon from "./../../components/svg/svg";


const Altimetrie = () => { // Partie découvrir

    // /////////////////////////////
    // Properties
    const noHeader = useContext(noHeaderContext)
    const programmeName = useContext(programmeNameContext)
    const contextDatas = useContext(programmeContext)
    const altimetrieDatas = contextDatas.pagesDetails.altimetrie
    const paletteBatiments = altimetrieDatas.batiments.map(b => b.name)
    const {setCurrent, setHeaderLevel} = useContext(pageContext)

    const [currentBat, setCurrentBat] = useState(null) // kr actif
    const [currentVim, setCurrentVim] = useState(null) // kr actif
    const [paletteList, setPaletteList] = useState(altimetrieDatas.batiments[0].panos.map(o => o.name))
    const [annotation, setAnnotation] = useState(null)
    const [canUseGyro, setCanUseGyro] = useState(false)
    const [gyro, setGyro] = useState(false)
    const [cardBoard, setCardBoard] = useState(false)

    const { containerRef, krpanoState, callKrpano } = useKrpano({
        // KRPano
        scriptPath: `${
          state === "local" ? "http://moteur-v6" : ""}/public/sources/krPanoBuilder/viewer/krpano.js`,
        embeddingParams: {
          swf: `${state === "local" ? "http://moteur-v6" : ""}/public/programmes/${programmeName}/altimetrie/tour.swf`,
          xml: `${state === "local" ? "http://moteur-v6" : ""}/public/programmes/${programmeName}/altimetrie/tour.xml`,
          target: "react-krpano",
          html: "prefer",
        },
        width : noHeader ? "100%" : "calc(100% - 100px)",
      });

    // /////////////////////////////
    // Effects
    useEffect(() => {
        // variable global pour effet krPano
        window.endVr = () => {
            setCardBoard(false)
            setGyro(false)
        }
        
        setCanUseGyro(navigator.platform !== "Win32")
    }, [])

    useEffect(() => { // Page courante pour le menu
        if (altimetrieDatas && !currentBat && !currentVim) {
            setCurrent("vues")
            setHeaderLevel(1)
            if (altimetrieDatas.batiments.length > 1) {
                setCurrentBat(altimetrieDatas.batiments.map(o => o.name)[0])
                setCurrentVim(altimetrieDatas.batiments[0].panos.map(o => o.name)[0])
            } else {
                setCurrentVim(altimetrieDatas.batiments[0].panos.map(o => o.name)[0])
            }
        }
       setAnnotation(altimetrieDatas?.annotationText)
    }, [altimetrieDatas, currentVim])

    useEffect(() => {
        if (currentBat) {
            // reset vim au changement de bat
            const batIndex = altimetrieDatas.batiments.findIndex(x => x.name === currentBat)
            console.log(altimetrieDatas.batiments[batIndex].panos.map(o => o.name))
            setCurrentVim(altimetrieDatas.batiments[batIndex].panos.map(o => o.name)[0])
            setPaletteList(altimetrieDatas.batiments[batIndex].panos.map(o => o.name))
        }
    }, [currentBat])

    useEffect(() => { // switch kr actif

        if (currentVim) {
            const kr = containerRef.current.children[0]
            const batIndex = altimetrieDatas.batiments.findIndex(x => x.name === currentBat)
            const correctVim = altimetrieDatas.batiments[batIndex].panos.filter(o => o.name === currentVim)[0]

            if (kr) {  
                kr.call(`loadscene('scene_${correctVim.scene}', null, MERGE, BLEND(0.5));`)

                callKrpano(`set(view.fov, ${correctVim.fov[1]})`)
                callKrpano(`set(view.fovmin, ${correctVim.fov[0]})`)
                callKrpano(`set(view.fovmax, ${correctVim.fov[2]})`)
                callKrpano(`set(view.limitview, range)`)
                callKrpano(`set(view.hlookat, ${correctVim.xStart})`)
                callKrpano(`set(view.vlookat, ${correctVim.yStart})`)
                callKrpano(`set(view.hlookatmin, ${correctVim.ranges.xMin})`)
                callKrpano(`set(view.hlookatmax, ${correctVim.ranges.xMax})`)
                callKrpano(`set(view.vlookatmin, ${correctVim.ranges.yMin})`)
                callKrpano(`set(view.vlookatmax, ${correctVim.ranges.yMax})`)
            }
        }
    }, [krpanoState.isEmbedded, currentVim])


    useEffect(() => {
        const kr = containerRef.current.children[0]
        if (kr) {
            if (cardBoard) {kr.call("webvr.enterVR();")} 
            else {kr.call("webvr.exitVR();")}
        }
    }, [cardBoard])
    
    useEffect(() => {
        const kr = containerRef.current.children[0]   
        if (kr) {
            if (gyro) {kr.set("plugin[skin_gyro].enabled", 'true')} 
            else  {kr.set("plugin[skin_gyro].enabled", 'false')}
        }
    }, [gyro])

    // /////////////////////////////
    // Render
    return <div id = 'altimetrie'>

        {/* Navigation */}
        <div 
            id ='altimetrieControllers' 
            className = {`${noHeader && paletteList.length > 1 ? "no-header-palette" : ""} ${noHeader && paletteList.length <= 1 ? "no-header" : ""}`}
            
            style = {{
                display : "flex",
                flexDirection : "column",
                gap : "50px"
            }}
            >
            
            {altimetrieDatas.batiments.length > 1 &&
                <Palette 
                    list = {paletteBatiments} 
                    current = {currentBat}
                    setCurrent = {setCurrentBat} 
                />
            }
            
            <Palette 
                list = {paletteList} 
                current = {currentVim}
                setCurrent = {setCurrentVim} 
            />
        </div>

        {/* Viewer */}
        <div ref={containerRef} style={{ position: 'absolute', width: '100%', height: '100%' }} />


        {/* SPECS : gyro/cardboard */}
        {(contextDatas.useVRforKr && canUseGyro) &&
            <>
            {navigator?.userAgent?.toLowerCase()?.includes("oculus") ? 
                /* Cas 1. occulus */
                <div id = "gyrocasque" style = {{display : "flex", flexDirection : "column"}}>
                {!cardBoard &&
                    <button id = "vrButton" className = {`no-hover ${cardBoard ? "mainBackground" : "inactive"}`} onClick = {() => setCardBoard(true)}>Lancer la VR</button>
                }
                </div>
                :
                /* Cas 2. mobile */
                <div id = "gyro">
                    <button className = {`${gyro ? "mainBackground" : "inactive"}`} onClick = {() => setGyro(g => !g)}>
                        <SvgIcon icon = "gyroscope" />
                    </button>     
                </div>
            }
            </>
        }

        {/* SPECS : annotation */}
        {annotation && <Annotation text = {annotation}></Annotation>}

    </div>
}

export default Altimetrie;